import lodash from 'lodash'
import types from '@/store/mutation-types'
import { getDepartments } from '@/api/departments/request'

const defaultState = {
  departments: [],
  sitesByUserDepOptions: [],
}

const getters = {
  allDepartment: state => state.departments,
}

const actions = {
  async getAllDepartments ({ commit }) {
    const departments = await getDepartments({sites: true, buildings: true})
    commit(types.GET_ALL_DEPARTMENTS, departments)
  },
}

const mutations = {
  [types.GET_ALL_DEPARTMENTS] (state, departments) {
    state.departments = departments
  },
}

export default {
  namespaced: true,
  state: lodash.cloneDeep(defaultState),
  getters,
  actions,
  mutations,
}
